export default "__VITE_ASSET__C8zsGU4p__"